/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_ClaimedInputs */

const en_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code Confirmed`)
};

const ar_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تأكيد الرمز`)
};

const de_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code bestätigt`)
};

const es_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código confirmado`)
};

const fr_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code confirmé`)
};

const it_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice confermato`)
};

const ja_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コード確認済み`)
};

const ko_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코드 확인됨`)
};

const pt_br_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código confirmado`)
};

const ru_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код подтвержден`)
};

const th_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันรหัสแล้ว`)
};

const tr_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kod onaylandı`)
};

const zh_cn_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请码已确认`)
};

const zh_tw_invite_claimed = /** @type {(inputs: Invite_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請碼已確認`)
};

/**
* | output |
* | --- |
* | "Code Confirmed" |
*
* @param {Invite_ClaimedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_claimed = /** @type {((inputs?: Invite_ClaimedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_ClaimedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_claimed(inputs)
	if (locale === "ar") return ar_invite_claimed(inputs)
	if (locale === "de") return de_invite_claimed(inputs)
	if (locale === "es") return es_invite_claimed(inputs)
	if (locale === "fr") return fr_invite_claimed(inputs)
	if (locale === "it") return it_invite_claimed(inputs)
	if (locale === "ja") return ja_invite_claimed(inputs)
	if (locale === "ko") return ko_invite_claimed(inputs)
	if (locale === "pt_br") return pt_br_invite_claimed(inputs)
	if (locale === "ru") return ru_invite_claimed(inputs)
	if (locale === "th") return th_invite_claimed(inputs)
	if (locale === "tr") return tr_invite_claimed(inputs)
	if (locale === "zh_cn") return zh_cn_invite_claimed(inputs)
	return zh_tw_invite_claimed(inputs)
});